import { render, staticRenderFns } from "./ValuationsPage.vue?vue&type=template&id=a9826350&scoped=true&"
import script from "./ValuationsPage.vue?vue&type=script&lang=js&"
export * from "./ValuationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9826350",
  null
  
)

export default component.exports